import React, { useContext, useState } from 'react'
import { Context } from '../../context/Context';
import { logout } from '../../redux/userRedux';
import { useDispatch, useSelector } from "react-redux";


export default function Topnav() {

  //const {user,dispatch} = useContext(Context);
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.currentUser);

  const handleLogout = () => {
    //dispatch({type:"LOGOUT"});
    dispatch(logout());
    window.location.reload();
  }
  //console.log(user)
  return (
    <nav className="navbar default-layout-navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row">
      <div className="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center">
        <a className="navbar-brand brand-logo" href="/dashboard">ELO</a>
        <a className="navbar-brand brand-logo-mini" href="/dashboard"><img src="assets/images/logo-mini.svg" alt="logo" /></a>
      </div>
      <div className="navbar-menu-wrapper d-flex align-items-stretch">
        <button className="navbar-toggler navbar-toggler align-self-center" type="button" data-toggle="minimize">
          <span className="mdi mdi-menu" />
        </button>
        <div className="search-field d-none d-md-block">
          <form className="d-flex align-items-center h-100" action="#">
            <div className="input-group">
              <div className="input-group-prepend bg-transparent">
                <i className="input-group-text border-0 mdi mdi-magnify" />
              </div>
              <input type="text" className="form-control bg-transparent border-0" placeholder="Search projects" />
            </div>
          </form>
        </div>
        <ul className="navbar-nav navbar-nav-right">
          <li className="nav-item nav-profile dropdown">
            <a className="nav-link dropdown-toggle" id="profileDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false">

              <div className="nav-profile-text">
                <p className="mb-1 text-black">{user?.returnObj.customerName}</p>
              </div>
            </a>
            <div className="dropdown-menu navbar-dropdown" aria-labelledby="profileDropdown">

              <a className="dropdown-item text-dark" href='/orders'>
                <i className="mdi mdi-logout me-2  text-primary" /> Orders </a>
              <a className="dropdown-item text-dark" href='/products'>
                <i className="mdi mdi-logout me-2 text-primary" /> Products </a>
              <a className="dropdown-item text-dark" href='/users'>
                <i className="mdi mdi-logout me-2 text-primary" /> Users </a>
              <a className="dropdown-item text-dark" href='/settings'>
                <i className="mdi mdi-logout me-2 text-primary" /> Settings </a>
              <a className="dropdown-item text-dark" onClick={handleLogout}>
                <i className="mdi mdi-logout me-2 text-primary" /> Signout </a>
            </div>
          </li>



        </ul>

      </div>
    </nav>
  )
}
